module.exports = __webpack_public_path__ + "img/bbhq.66e7d900.jpg";